import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { GameHubControllerService } from '../gameHub/game-hub-controller';
import { UserSessionService } from '../user-session/user-session.service';
import { Navigator } from '../routing/navigator';

@Injectable({
  providedIn: 'root'
})
export class GameTileService {

  public isAuthenticated: boolean = false;
  private _waitingGameData: any;
  private defaultGameImageConfig: string;
  public vendorsThatSupportDemoPlay = {
    'ags': false,
    'everi': false,
    'evolution': false,
    'netent': false,
    'igt': true,
    'internal': true,
    'microgaming': true,
    'nyx': true,
    'slingo': true,
  };

  constructor(
    private config: ConfigService,
    private gameHubController: GameHubControllerService,
    private navigator: Navigator,
    private userSession: UserSessionService,
  ) {
    this.defaultGameImageConfig = this.config.getConfig()['FEATURE_LOBBY_GAME_DEFAULT_IMAGE'] ?? 'tile_loader_image.svg';
    this.initializeDemoPlayConfig();
  }

  private initializeDemoPlayConfig() {
    if (this.config.getConfig()['FEATURE_VENDOR_DEMO']) {
      try {
        const configVendors = JSON.parse(this.config.getConfig()['FEATURE_VENDOR_DEMO'].replace(/'/g, '"'));
        this.vendorsThatSupportDemoPlay = configVendors;
      }
      catch (error) {
        console.error('Error parsing FEATURE_VENDOR_DEMO config:', error);
      }
    }
  }

  public get galleryImagePath(): string {
    return `${this.config?.getConfig()?.CDN_BASEURL}/assets/social/games/`;
  }

  public getTileImage(gameData: any): string {
    return gameData?.imagename ? `${this.galleryImagePath}${gameData.imagename}` : '';
  }

  public get tileDefaultImage(): string {
    return `${this.config?.getConfig()?.CDN_BASEURL}/assets/imgs/${this.defaultGameImageConfig}`;
  }

  public launchGame(gameData: any): any {
    if (!this.userSession.isAuthenticated()) {
      this.waitingGameData = gameData;
      return this.navigator.navigateTo("LoginComponent");
    }
    return this.gameHubController.launchCasinoGame(gameData);
  }

  public launchDemoGame(gameData: any): any {
    if (this.userSession.isAuthenticated()) {
      return this.gameHubController.launchCasinoGameDemo(gameData);
    }
    this.navigator.toAgeVerificationModal(gameData);
  }

  public onGameInfo(gamedata: any): void {
    this.navigator.navigateTo('GameDetailsComponent', { multipleModals: false }, { gamedata });
  }

  public get waitingGameData(): any {
    return this._waitingGameData;
  }

  public set waitingGameData(data: any) {
    this._waitingGameData = data;
  }

  public isDemoGame(gameData: any) {
    const vendorIdent = gameData?.vendor_ident?.toLowerCase();
    return vendorIdent in this.vendorsThatSupportDemoPlay ?
      this.vendorsThatSupportDemoPlay[vendorIdent] : false;
  }
}
